
<div class="relative" :class="dropdownClasses">
  <label :class="dropdownSelectedOption" :for="id">{{ labelName }}</label>
  <select
    :id="id"
    v-model="selectedOption"
    class="dropdown-input"
    :aria-invalid="hasError"
    :aria-describedby="ariaDescribedByName"
    :required="required"
    :disabled="disabled"
    :name="name"
    @blur="$emit('blur')"
  >
    <!-- needs to accept an object or an array -->
    <option
      v-for="(option, index) in options"
      :id="index"
      :key="index"
      :value="option.hasOwnProperty('value') ? option.value : option"
    >
      {{ option.display ? option.display : option }}
    </option>
  </select>
  <slot />
  <HelperText :id="id" :status="status" :text="helperText" />
</div>
